import loader from "./loader";

const KLARNA_CLIENT_ID_US = "55bd9eca-0a86-5ff3-abae-744086cdbe0b";
const KLARNA_CLIENT_ID_EU = "74b2d614-7381-5cc8-95ab-14551568cbdf";

const KLARNA_SCRIPT_SRC_US = "https://na-library.klarnaservices.com/lib.js";
const KLARNA_SCRIPT_SRC_EU = "https://eu-library.klarnaservices.com/lib.js";

export function load(country) {
    const clientId = country === "US" ? KLARNA_CLIENT_ID_US : KLARNA_CLIENT_ID_EU;
    const src = country === "US" ? KLARNA_SCRIPT_SRC_US : KLARNA_SCRIPT_SRC_EU;

    loader(() => {
        let d = document;
        let g = d.createElement("script");
        let s = d.getElementsByTagName("script")[0];
        g.type = "text/javascript";
        g.async = true;
        g.src = src;
        g.dataset.clientId = clientId;
        s.parentNode.insertBefore(g, s);
    })();
}
